import { createEntityAdapter } from '@reduxjs/toolkit';

const interactiveCreativesAdapter = createEntityAdapter();

export default interactiveCreativesAdapter;
